import api from '../../api/userAPI';
import { setErrorNotification } from '../snackbarNotification';

export const FETCH_BEGIN = 'participant.list/FETCH_BEGIN';
export const FETCH_SUCCESS = 'participant.list/FETCH_SUCCESS';
export const FETCH_FAILED = 'participant.list/FETCH_FAILED';

const fetchBegin = () => ({ type: FETCH_BEGIN });
const fetchSuccess = data => ({ type: FETCH_SUCCESS, payload: data });
const fetchFailed = error => ({ type: FETCH_FAILED, payload: error });
export const fetchParticipantsList = () => async dispatch => {
  dispatch(fetchBegin());

  try {
    const res = await api('retrieve-participants');

    dispatch(fetchSuccess(res.data.result));
  } catch (error) {
    dispatch(fetchFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_BEGIN:
      return { ...state, error: null, isFetching: true };
    case FETCH_SUCCESS:
      return { ...state, data: payload, isFetching: false };
    case FETCH_FAILED:
      return { ...state, error: payload, isFetching: false };

    default:
      return state;
  }
};

export default reducer;

const initialState = {
  data: [],
  isFetching: false,
  error: null
};
